module.exports = __webpack_public_path__ + "img/tool-check.e4f9c1a.webp";